import React, { useState } from "react";
import Button from "../../Button/Button";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    // console.log(formData);
    try {
      console.log("Request Sended...");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      const jsonResponse = await response.json();
      console.log(jsonResponse.msg);
      console.log("response received...");
    } catch (err) {
      console.log(err.message);
    }

    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    });
  };

  return (
    <div className="flex items-center text-white justify-center -mt-16 min-h-screen w-full  md:my-20 ">
      <form className="w-full max-w-[90%]  py-10 px-4  md:px-32 bg-white/5 gap-3 md:gap-10 flex items-center flex-col font-poppins rounded-lg">
        {/* Name Input */}
        <div className="flex flex-wrap justify-between w-full md:gap-5">
          <div className="mb-4 w-full">
            <label
              htmlFor="name"
              className="block text-gray-200/50 font-extralight text-xl md:text-3xl  mb-2"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border bg-white/5 border-gray-100/15 h-14 md:h-20  rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
              required
            />
          </div>

          {/* Phone Number Input */}
          <div className="md:mb-4 w-full">
            <label
              htmlFor="name"
              className="block text-gray-200/50 font-extralight text-xl md:text-3xl mb-2"
            >
              Phone Number
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border bg-white/5 border-gray-100/15 h-14 md:h-20 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
              required
            />
          </div>
        </div>

        {/* Email Input */}
        <div className="md:mb-4 w-full">
          <label
            htmlFor="name"
            className="block text-gray-200/50 font-extralight text-xl md:text-3xl mb-2"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border bg-white/5 border-gray-100/15 h-14 md:h-20 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            required
          />
        </div>

        {/* Message Input */}
        <div className="md:mb-4 w-full">
          <label
            htmlFor="name"
            className="block text-gray-200/50 font-extralight text-xl md:text-3xl mb-2"
          >
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-2 min-h-48  border bg-white/5 border-gray-100/15 h-14 md:h-20 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            rows="10"
            required
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="text-center" onClick={handleSubmit}>
          <Button title={"Get Started"} />
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
